var CryptoJS = require("crypto-js");
var $ = require( "jquery" );

export default function signature(queryString = "") {
  const jsx = require("js-extension-ling");
  const params = jsx.queryStringToObject(queryString);
  const key = process.env.VUE_APP_KEY;
  const partnerAppSecret = process.env.VUE_APP_SECRET;
  const timestamp = new Date().getTime();
  let query = Object.entries(params).reduce((a, [k, v]) => (v ? (a[k] = v, a) : a), {});
  query = {
    ...query, ...{
      key, timestamp
    }
  };
  let baseString = `secret=${partnerAppSecret}`;
  for (const key of Object.keys(query).sort()) {
    if ((typeof query[key] === "object" || typeof query[key] === 'function') && (query[key] !== null)) {
      let dataValue = Object.values(query[key]);
      query[key] = [];
      dataValue.map(function(value){
        query[key].push(value);
        baseString += `${key}[]=${value}`
      });
    } else if (Array.isArray(query[key])) {
      for (const value of query[key]) {
        baseString += `${key}[]=${value}`
      }
    } else {
      baseString += `${key}=${query[key]}`
    }
  }
  
  const hmac = CryptoJS.HmacSHA256(baseString, partnerAppSecret);
  const signature = hmac.toString(CryptoJS.digest);

  query = { ...query, signature };

  return '?' + $.param(query);
}